import { usePlayer } from "../context/PlayerContext";
import { useLanguage } from "../context/LanguageContext";
import { Equalizer } from "./player/Equalizer";
import { TrackRow } from "./player/TrackRow";
import { PlayerControls, MobilePlayer } from "./player/PlayerControls";
export { Equalizer } from "./player/Equalizer";

export default function Player() {
  const { t } = useLanguage();
  const { tracks, isPlaying, error } = usePlayer();
  return <>
    <aside data-testid="player-sidebar" className="fixed right-0 top-0 z-40 hidden h-screen w-80 flex-col border-l border-[#282C3D] bg-[#0E1018] lg:flex">
      <div className="border-b border-[#282C3D] p-5">
        <div className="flex items-center justify-between"><p className="eyebrow">{t("Studio Player")}</p><Equalizer playing={isPlaying} /></div>
        <p className="mt-1 text-xs text-slate-500">{t("Songs produced by Evi-Studio")}</p>
        {error && <p role="alert" data-testid="player-error" className="mt-2 text-xs text-rose-300">{t(error)}</p>}
      </div>
      <PlayerControls />
      <div className="flex-1 space-y-1 overflow-y-auto p-3">{tracks.map((track, position) => <TrackRow key={track.id} track={track} position={position} />)}</div>
    </aside>
    <MobilePlayer />
  </>;
}